export const BASE_URL = (
  import.meta.env.MODE === 'production'
    ? 'https://api.draftlegal.ai'
    : 'http://localhost:5013'
);